import { action, createRequestTypes } from '../base';

export const resourceActionTypes = {
  GET_RESOURCE: createRequestTypes('GET_RESOURCE'),
  GET_RESOURCE_BY_ID: createRequestTypes('GET_RESOURCE_BY_ID'),
  CREATE_RESOURCE: createRequestTypes('CREATE_RESOURCE'),
  UPDATE_RESOURCE: createRequestTypes('UPDATE_RESOURCE'),
  UPDATE_STATUS_RESOURCE: createRequestTypes('UPDATE_STATUS_RESOURCE'),
  DELETE_RESOURCE: createRequestTypes('DELETE_RESOURCE'),
  GET_RESOURCE_GROUP: createRequestTypes('GET_RESOURCE_GROUP'),
  CREATE_RESOURCE_GROUP: createRequestTypes('CREATE_RESOURCE_GROUP'),
  UPDATE_RESOURCE_GROUP: createRequestTypes('UPDATE_RESOURCE_GROUP'),
  DELETE_RESOURCE_GROUP: createRequestTypes('DELETE_RESOURCE_GROUP'),
};

/**
 * @param payload
 * @param orgId
 * @param status
 * @param limit
 * @param page
 * @param callback
 */
class ResourceActions {
  /**
   * @param {*} orgId
   * @param {*} searchKeyword
   * @param {*} page
   * @param {*} limit
   * @return
   */
    getResource = (orgId, page, limit, searchKeyword, tenantIds, resourceType, resourceStatus, isDropdown) => action(resourceActionTypes.GET_RESOURCE.REQUEST, {
      orgId, page, limit, searchKeyword, tenantIds, resourceType, resourceStatus, isDropdown,
    })

    /**
     *
     * @param {*} getResourceLoading
     * @return
     */
     getResourceLoading = (getResourceLoading) => action(resourceActionTypes.GET_RESOURCE.LOADING, {
       getResourceLoading,
     })

     /**
      * @return
      * @param resources
      */
     getResourceSuccess = (resources, isDropdown) => action(resourceActionTypes.GET_RESOURCE.SUCCESS, {
       resources, isDropdown,
     })

     /**
      * @param orgId
      * @param {*} resourceId
      * @return
      */
     getResourceById = (orgId, resourceId) => action(resourceActionTypes.GET_RESOURCE_BY_ID.REQUEST, {
       orgId, resourceId,
     })

     /**
      *
      * @param {*} getResourceByIdLoading
      * @return
      */
     getResourceByIdLoading = (getResourceByIdLoading) => action(resourceActionTypes.GET_RESOURCE_BY_ID.LOADING, {
       getResourceByIdLoading,
     })

     /**
      * @return
      * @param selectedResource
      * @param resourceData
      */
      getResourceByIdSuccess = (selectedResource) => action(resourceActionTypes.GET_RESOURCE_BY_ID.SUCCESS, {
        selectedResource,
      })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    createResource = (payload, callback) => action(resourceActionTypes.CREATE_RESOURCE.REQUEST, {
      payload,
      callback,
    })

    /**
     *
     * @param {*} createResourceLoading
     * @return
     */
    createResourceLoading = (createResourceLoading) => action(resourceActionTypes.CREATE_RESOURCE.LOADING, {
      createResourceLoading,
    })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
     updateResource = (payload, callback) => action(resourceActionTypes.UPDATE_RESOURCE.REQUEST, {
       payload,
       callback,
     })

     /**
      *
      * @param {*} updateResourceLoading
      * @return
      */
     updateResourceLoading = (updateResourceLoading) => action(resourceActionTypes.UPDATE_RESOURCE.LOADING, {
       updateResourceLoading,
     })

    /**
     * @param payload
     * @param callback
     * @return {{type: *}}
     */
    updateResourceStatus = (payload, callback) => action(resourceActionTypes.UPDATE_STATUS_RESOURCE.REQUEST, {
      payload, callback,
    })

    /**
     * @param updateResourceStatusLoading
     * @return {{type: *}}
     */
     updateResourceStatusLoading = (updateResourceStatusLoading) => action(resourceActionTypes.UPDATE_STATUS_RESOURCE.LOADING, {
       updateResourceStatusLoading,
     })

     /**
      * @param payload
      * @param callback
      * @return {{type: *}}
      */
    deleteResource = (payload, callback) => action(resourceActionTypes.DELETE_RESOURCE.REQUEST, {
      payload, callback,
    })

    /**
     *
     * @param deleteResourceLoading
     * @returns {{type: *}}
     */
    deleteResourceLoading = (deleteResourceLoading) => action(resourceActionTypes.DELETE_RESOURCE.LOADING, {
        deleteResourceLoading,
    })

    /**
     * @param deleteResourceGroupLoading
     * @return {{type: *}}
     */
     deleteResourceGroupLoading = (deleteResourceGroupLoading) => action(resourceActionTypes.DELETE_RESOURCE_GROUP.LOADING, {
       deleteResourceGroupLoading,
     })

     /**
   * @param {*} orgId
   * @param {*} searchKeyword
   * @param {*} page
   * @param {*} limit
   * @return
   */
     getResourceGroup = (orgId, searchKeyword, callback) => action(resourceActionTypes.GET_RESOURCE_GROUP.REQUEST, {
       orgId, searchKeyword, callback,
     })

     /**
     *
     * @param {*} getResourceGroupLoading
     * @return
     */
     getResourceGroupLoading = (getResourceGroupLoading) => action(resourceActionTypes.GET_RESOURCE_GROUP.LOADING, {
       getResourceGroupLoading,
     })

     /**
      * @return
      * @param resourcesGroup
      */
     getResourceGroupSuccess = (resourcesGroup) => action(resourceActionTypes.GET_RESOURCE_GROUP.SUCCESS, {
       resourcesGroup,
     })

     /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    createResourceGroup = (payload, callback) => action(resourceActionTypes.CREATE_RESOURCE_GROUP.REQUEST, {
      payload,
      callback,
    })

    /**
     *
     * @param {*} createResourceGroupLoading
     * @return
     */
    createResourceGroupLoading = (createResourceGroupLoading) => action(resourceActionTypes.CREATE_RESOURCE_GROUP.LOADING, {
      createResourceGroupLoading,
    })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
     updateResourceGroup = (payload, callback) => action(resourceActionTypes.UPDATE_RESOURCE_GROUP.REQUEST, {
       payload,
       callback,
     })

     /**
      *
      * @param {*} updateResourceGroupLoading
      * @return
      */
     updateResourceGroupLoading = (updateResourceGroupLoading) => action(resourceActionTypes.UPDATE_RESOURCE_GROUP.LOADING, {
       updateResourceGroupLoading,
     })

     /**
      * @param payload
      * @param callback
      * @return {{type: *}}
      */
        deleteResourceGroup = (payload, callback) => action(resourceActionTypes.DELETE_RESOURCE_GROUP.REQUEST, {
          payload, callback,
        })

        /**
         * @param deleteResourceGroupLoading
         * @return {{type: *}}
         */
         deleteResourceGroupLoading = (deleteResourceGroupLoading) => action(resourceActionTypes.DELETE_RESOURCE_GROUP.LOADING, {
           deleteResourceGroupLoading,
         })
}

export default new ResourceActions();
